import { z } from 'zod'

export const timeSeriesSchema = z.object({
  instrument_type_ids: z.array(z.coerce.number().int().positive()).min(1),
  instrument_ids: z.array(z.coerce.number().int().positive()).min(1).max(20),
  dates: z.object({
    from: z.coerce.date(),
    to: z.coerce.date(),
  }),
  database: z.literal(['new', 'old', 'both']),
})

export type TimeSeriesSchemaType = z.infer<typeof timeSeriesSchema>
